import { useIntl, defineMessages } from 'react-intl'
import { useDispatch } from 'react-redux'
import { saveClientAnswer } from '../../../../actions/client'
import { add, format, startOfMonth } from 'date-fns'
import { useTrackingContext } from '../../../../providers/tracking'
import { QUESTION_DATE, NEW_STEPS } from '../../../../constants/client/onboarding'
import { OnboardingModalTitle } from './OnboardingModalTitle'
import { ButtonGroup, Button, Input, FormLabel, FormControl, useToast } from '@homebotapp/hb-react-component-catalog'
import { useState } from 'react'
import { StepContainer } from './StepContainer'
import { TrackingEventConstants } from '../../../../constants/tracking'

export const MSG = defineMessages({
  successMessage: {
    id: 'BuyerOnboardingWizard.successMessage',
    defaultMessage: 'Search profile is 100% complete'
  },
  skipForNow: {
    id: 'BuyerOnboarding.skipForNow',
    defaultMessage: 'Skip for now'
  },
  next: {
    id: 'BuyerOnboarding.next',
    defaultMessage: 'Next'
  },
  estimatedMoveDate: {
    id: 'BuyerOnboarding.estimatedMoveDate',
    defaultMessage: 'Estimated move date'
  },
  finish: {
    id: 'BuyerOnboarding.finish',
    defaultMessage: 'Finish'
  }
})

interface EnterCloseDateProps {
  getTotalStepsLeftToComplete: () => number
  handleNavigation: (saveCurrentStepData?: () => void) => void
  hasFavoriteMarkets: boolean
}

export const EnterCloseDate = ({
  getTotalStepsLeftToComplete,
  handleNavigation,
  hasFavoriteMarkets
}: EnterCloseDateProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const toast = useToast()
  const { trackingClient } = useTrackingContext()
  const maxDate = startOfMonth(add(new Date(), { months: 12 }))
  const [selectedDate, setSelectedDate] = useState(undefined)

  const saveCloseDate = () => {
    const date = new Date(selectedDate)

    trackingClient?.buyerOnboarded({
      // @ts-ignore
      close_timeline: format(date, 'MMM').toLowerCase()
    })
    dispatch(
      saveClientAnswer({
        question: QUESTION_DATE,
        response: {
          value: format(date, 'yyyy-MM-dd')
        }
      })
    )
  }

  const handleSkipForNow = () => {
    handleNavigation()
  }

  const handleNext = () => {
    if (selectedDate) {
      handleNavigation(() => saveCloseDate())
      if (getTotalStepsLeftToComplete() === 1 && hasFavoriteMarkets) {
        toast({
          title: intl.formatMessage(MSG.successMessage),
          status: 'success'
        })
      }
    }
  }

  return (
    <StepContainer data-qa='enter-close-date'>
      <OnboardingModalTitle currentStep={NEW_STEPS.BUYER_CLOSE_DATE} />
      <FormControl>
        <FormLabel>{intl.formatMessage(MSG.estimatedMoveDate)}</FormLabel>
        <Input
          type='date'
          onChange={e => setSelectedDate(e.target.value)}
          name={'close-date-picker'}
          min={format(new Date(), 'yyyy-MM-dd')}
        />
      </FormControl>

      <ButtonGroup justifyContent='end' mt={3}>
        <Button
          tracking={{
            guid: 'kRzoMddxc3pcJPLLdVsAwa',
            ui_context: TrackingEventConstants.BUYING_ONBOARDING_WIZARD_SKIP_FOR_NOW,
            descriptor: MSG.skipForNow.defaultMessage
          }}
          onClick={handleSkipForNow}
        >
          {intl.formatMessage(MSG.skipForNow)}
        </Button>
        <Button isDisabled={!selectedDate} colorScheme='primary' onClick={handleNext}>
          {getTotalStepsLeftToComplete() === 1 ? intl.formatMessage(MSG.finish) : intl.formatMessage(MSG.next)}
        </Button>
      </ButtonGroup>
    </StepContainer>
  )
}
